import { Component, Vue } from 'vue-property-decorator'

@Component
export class DisabledInput extends Vue {
  disabledInputProps = { 'background-color': 'grey lighten-4', color: 'grey darken-1', outlined: true }
}
